import {
  BLOCK_IMPORTER_REQUEST,
  COMBINED_LIST_REQUEST,
  COMBINED_LIST_RESPONSE,
  EXPORTERS_LIST_REQUEST,
  EXPORTERS_LIST_RESPONSE,
  GET_COMPANY_CONTACT_INFO_REQUEST,
  GET_COMPANY_CONTACT_INFO_RESPONSE,
  GET_EXPORTER_ACCOUNT_INFO_REQUEST,
  GET_EXPORTER_ACCOUNT_INFO_RESPONSE,
  GET_EXPORTER_COMPANY_DETAILS_REQUEST,
  GET_EXPORTER_COMPANY_DETAILS_RESPONSE,
  GET_EXPORTER_CONTACT_INFO_REQUEST,
  GET_EXPORTER_CONTACT_INFO_RESPONSE,
  GET_EXPORTER_TRANSACTIONS_LIST_REQUEST,
  GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE,
  GET_EXPORTER_VERIFICATION_INFO_REQUEST,
  GET_EXPORTER_VERIFICATION_INFO_RESPONSE,
  GET_IMPORTER_DETAILS_REQUEST,
  GET_IMPORTER_DETAILS_RESPONSE,
  IMPORTERS_LIST_REQUEST,
  IMPORTERS_LIST_RESPONSE,
  UNBLOCK_IMPORTER_REQUEST
} from "./types";

export const importersListRequest = (payload) => ({
  type: IMPORTERS_LIST_REQUEST,
  payload
});
export const importersListResponse = (payload) => ({
  type: IMPORTERS_LIST_RESPONSE,
  payload
});

export const exportersListRequest = (payload) => ({
  type: EXPORTERS_LIST_REQUEST,
  payload
});
export const exportersListResponse = (payload) => ({
  type: EXPORTERS_LIST_RESPONSE,
  payload
});

export const getImporterDetailsRequest = (payload) => ({
  type: GET_IMPORTER_DETAILS_REQUEST,
  payload
});
export const getImporterDetailsResponse = (payload) => ({
  type: GET_IMPORTER_DETAILS_RESPONSE,
  payload
});

export const getExporterCompanyDetailsRequest = (payload) => ({
  type: GET_EXPORTER_COMPANY_DETAILS_REQUEST,
  payload
});
export const getExporterCompanyDetailsResponse = (payload) => ({
  type: GET_EXPORTER_COMPANY_DETAILS_RESPONSE,
  payload
});

export const getExporterContactInfoRequest = (payload) => ({
  type: GET_EXPORTER_CONTACT_INFO_REQUEST,
  payload
});
export const getExporterContactInfoResponse = (payload) => ({
  type: GET_EXPORTER_CONTACT_INFO_RESPONSE,
  payload
});

export const getExporterVerificationInfoRequest = (payload) => ({
  type: GET_EXPORTER_VERIFICATION_INFO_REQUEST,
  payload
});
export const getExporterVerificationInfoResponse = (payload) => ({
  type: GET_EXPORTER_VERIFICATION_INFO_RESPONSE,
  payload
});

export const getExporterTransactionsListRequest = (payload) => ({
  type: GET_EXPORTER_TRANSACTIONS_LIST_REQUEST,
  payload
});
export const getExporterTransactionsListResponse = (payload) => ({
  type: GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE,
  payload
});

export const getCompanyContactInfoRequest = (payload) => ({
  type: GET_COMPANY_CONTACT_INFO_REQUEST,
  payload
});
export const getCompanyContactInfoResponse = (payload) => ({
  type: GET_COMPANY_CONTACT_INFO_RESPONSE,
  payload
});

export const getExporterAccountInfoRequest = (payload) => ({
  type: GET_EXPORTER_ACCOUNT_INFO_REQUEST,
  payload
});
export const getExporterAccountInfoResponse = (payload) => ({
  type: GET_EXPORTER_ACCOUNT_INFO_RESPONSE,
  payload
});

export const blockImporterRequest = (payload) => ({
  type: BLOCK_IMPORTER_REQUEST,
  payload
});

export const unblockImporterRequest = (payload) => ({
  type: UNBLOCK_IMPORTER_REQUEST,
  payload
});

export const combinedListRequest = (payload) => ({
  type: COMBINED_LIST_REQUEST,
  payload
});

export const combinedListResponse = (payload) => ({
  type: COMBINED_LIST_RESPONSE,
  payload
});
